var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isProduction)?_c('v-chip',{class:_vm.environmentClass},[_c('b',{staticClass:"text-truncate"},[_vm._v(_vm._s(_vm.environment))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }